class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.mobileMenu = document.querySelector('mobile-menu');
    this.headerSearch = document.querySelectorAll('header-search');

    this.querySelector('.icon-close').addEventListener('click', this.close.bind(this));
  }

  close() {
    // 1. Close AB
    this.classList.add('hidden');

    // 2. Update Main Content padding top
    const mainContent = document.querySelector('.main-content');
    const headerHeight = getComputedStyle(document.querySelector('.sticky-header')).height;
    mainContent.style.paddingTop = headerHeight;

    // 3. Adjust Facets top position
    this.desktopFacets();

    // 4. Adjust mobile menu height
    this.mobileMenu.mobileMenuHeight();

    // 5. Adjust search suggestions height
    this.headerSearch.forEach(search => search.searchSuggestionsHeight());
  }

  desktopFacets() {
    const contentWithFacets = document.querySelector('#content-with-facets');
    if (!contentWithFacets) return;

    if (window.innerWidth >= 990) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = parseInt(getComputedStyle(contentWithFacets.stickyHeader).height);
      const ContentWithFacetsOffsetTop = contentWithFacets.offsetTop;
  
      if ((scrollTop + headerHeight) > ContentWithFacetsOffsetTop) {
        // Add 'sticky' class
        contentWithFacets.desktopFacetsEl.classList.add('sticky');
      } else {
        // Remove 'sticky' class
        contentWithFacets.desktopFacetsEl.classList.remove('sticky');
      }
  
      // Adjust top position
      contentWithFacets.desktopFacetsEl.style.top = getComputedStyle(contentWithFacets.stickyHeader).height;
      for (let i = 1; i <= 300; i++) {
        setTimeout(() => {
          contentWithFacets.desktopFacetsEl.style.top = getComputedStyle(contentWithFacets.stickyHeader).height;
        }, i);
      }
    } else {
      contentWithFacets.desktopFacetsEl.classList.remove('sticky');
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);